module.exports = __webpack_public_path__ + "img/rcln1.4579f8b5.jpg";